import { UseCustomAxios } from "../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../util/Utils";

export function UseMagManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const AllComponents = (callback) => {
    MyAxios.get(`Admin_Mag_HomePage/AllComponents`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetComponents = (callback, bool) => {
    MyAxios.get(`Admin_Mag_HomePage/GetComponents`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetComponents = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Mag_HomePage/SetComponents`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای مجله با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const removeComponent = (HID, callback) => {
    const data = new FormData();
    data.append("HID", HID);
    MyAxios.delete(`Admin_Mag_HomePage/RemoveComponent`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کامپوننت با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const ResetHeaderFooterCache = (callback) => {
    MyAxios.post(`Admin_Mag_HomePage/ResetHeaderFooterCache`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    AllComponents,
    GetComponents,
    validate,
    removeComponent,
    SetComponents,
    ResetHeaderFooterCache,
  };
}
